export enum STATUS {
    ALL = '4',
    OPEN = '1',
    CLOSED = '2',
    CREDIT = '3',
}

// Opsi untuk select
export const STATUS_OPTIONS = [
    { value: STATUS.ALL, label: 'ALL' },
    { value: STATUS.OPEN, label: 'OPEN' },
    { value: STATUS.CLOSED, label: 'CLOSED' },
    { value: STATUS.CREDIT, label: 'CREDIT' },
];

// = untuk menampilkan label dari value
export const getStatusLabel = (value: string): string => {
    const found = STATUS_OPTIONS.find((opt) => opt.value === value);
    return found ? found.label : 'Unknown';
};